<ngb-toast
  [autohide]="toast.autohide"
  [delay]="toast.delay || 5000"
  [class]="toast.class"
  (hidden)="onClose()"
>
  <ng-template ngbToastHeader>
    <div
      [ngClass]="{
        'ms-auto me-auto': toast.centerHeader,
        'me-auto': !toast.centerHeader
      }"
    >
      <label class="fw-normal color-white">{{ toast.header }}</label>
    </div>
  </ng-template>
  {{ toast.body }}
</ngb-toast>
